import { useState } from 'react';

export default function ClickToPlayVideo({ src, className = '', thumbClassName = '' }) {
  const [playVideo, setPlayVideo] = useState(false);

  if (!playVideo) {
    return (
      <button
        type="button"
        className={`video-thumb-wrap ${thumbClassName}`.trim()}
        onClick={() => setPlayVideo(true)}
        aria-label="Click to play video"
      >
        <video className={`${className} media-thumb-preview`.trim()} preload="metadata" muted playsInline>
          <source src={src} />
        </video>
        <span className="video-thumb-overlay">Click to play</span>
      </button>
    );
  }

  return (
    <video className={className} controls preload="metadata" autoPlay>
      <source src={src} />
      Your browser does not support video.
    </video>
  );
}
